// extracted by mini-css-extract-plugin
module.exports = {"support_container":"Support-module__support_container___3xy9R"};